export const getBuilderWidgetClass = (builderWidgetId: string) => {
	return `w-${builderWidgetId}`
}

export const getWrapperSelectorForWidget = (builderWidgetId: string) => {
	return `.${getBuilderWidgetClass(builderWidgetId)}`
}

export const getBuilderComponentInstanceClass = (componentId: string) => {
	return `c-${componentId}`
}

export const getWrapperSelectorForComponent = (componentId: string) => {
	return `.${getBuilderComponentInstanceClass(componentId)}`
}
